import styled from 'styled-components';
import { BasketPriceDetailsStyled } from '../BasketPriceDetailsStyled';
import { rem } from 'polished';

export const BasketPriceDetailsDS = styled(BasketPriceDetailsStyled)``;
